import { render, staticRenderFns } from "./ISAAlertListVideoHelp.vue?vue&type=template&id=dc3d5ec6&scoped=true&"
import script from "./ISAAlertListVideoHelp.vue?vue&type=script&lang=js&"
export * from "./ISAAlertListVideoHelp.vue?vue&type=script&lang=js&"
import style0 from "./ISAAlertListVideoHelp.vue?vue&type=style&index=0&id=dc3d5ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3d5ec6",
  null
  
)

export default component.exports